import axiosInstance from './AxiosInstance';

const StateService = {
  fetchStates: async (page = 1, pageSize = 55) => {
    try {
      const response = await axiosInstance.get('/states', {
        params: { page, pageSize }, // Query parameters
      });
      console.log("States result:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching states:", error);
      throw error; // Propagate the error for caller to handle
    }
  },
};

export default StateService;
